module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "ملحوظة"
    }
  }, [_c('p', {
    staticStyle: {
      "padding-top": "150px",
      "text-indent": "1em !important"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مِن أشهر مقولات عماد الدين الأصفهاني:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("\"إنِّي رأيتُ أنَّه لا يكتب إنسانٌ كتابًا في يومه إلا قال في غده: لو غُيِّر هذا لكان أحسن، ولو زِيدَ كذا لكان يُسْتَحسن، ولو قُدِّمَ هذا لكان أفضل، ولو تُرِك هذا لكان أجمل، وهذا مِن أعظَم العِبر، وهو دليلٌ على استيلاء النَّقص على جملة البشر\".")]), _vm._v("s")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdde7154","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 78
// module chunks = 0